export default __webpack_public_path__ + "static/media/SLD3-A.88fefb26.png";